
/**
 * Should start subclassing the pages by type (eg GOS).
 * Would probably want to create from factory -- though for time being may be simpler with
 * conditional statements in here.
 */


var Backbone = require('backbone'),
    Util = require('../../../FV/util.js'),
    ViewerSettings = require('../../settings/settings'),
    PageNotes = require('../../../notes/models/page/pgNotes'),
    PgNameXref = require('./pageTypeXref'),
    ShapeUtils = require('../../../canvas/models/shapeUtils'),
    fvChannel = require('glRadio').channel('FV');


// put standard dims on viewer settings ...
// where did these numbers come from? (8.5 x 11 ?)
var STANDARD_PG_DIMS = {
    h: 2244,
    w: 1728
};


module.exports = Backbone.Model.extend({

  /*  TODO:
   *divide into ui, non ui - REALLY NEED TO CREATE A CHILD UI MODEL FOR THE NON SERVER ATTRIBUTES
    * clear up terminology: eg  WHAT THE WIDTH AND HT VALUES MEAN
 * */
    STANDARD_PG_DIMS: STANDARD_PG_DIMS,
    unknownOrigDimsDimensions: STANDARD_PG_DIMS,
    SPIN_JS_OPTS: { top: '15%', length: 6, radius: 6, width: 2, lines: 13 }, //the default, should always be overwritten by subclasses


    /**
     * isRenderable:
     * - refers to whehter a page is renderable ( will be shown in viewer ); does not imply GOS or has unknown dimensions
     * - set on init -- based off file ext --- if gos and not a valid file extension
     * DVBC-1423:
     * - make defaults a function so the new notes collection is a different instance when extended by the other page models
     * - cleaner than setting on init/parse b/c the full page model on viewer.state is recreated on each page change
     * TODO:
     *  - put only the server attributes here
     *  - make these other ones instance variables
     * Note: server attribute rotation
     *  - this can now be different from the value in the DB with users who lack rotation permission.
     *  - it's set on fetch, when rotation changes, and overwritten on viewer reset / open new window functionality
     *  - for now not storing the original and a different value
     *  - The viewer is now handling everything with 0 rotation and then displaying/exporting with an adjustment for the rotation
     */
    defaults: function() {

        return {

            isRenderable: true,
            number: 0,

            /* height and width always in pixels (cold pages original attributes may be in inches) */
            /* now unscaled and unrotated -- the could be 'derived' in the case doc mode and thumbnails  */
            width: 0,
            height: 0,

            /*  TODO: vOffset: -- its set when used ...
                 the thresholds to change page for scrolling up / down in doc-mode-container:
                 (pgHeight * scale) + vPadding (of current page plus all those above it)
                 really the scroll top position of the top of the next element in the scrolling container (including padding)
             /* now init'd by get set width, getHeight derived from width

             /* would also equal the size of the el for the pg, which includes padding */

            parentDocument: null,
            imageFileType: null,

            textGridModel: null, /* exclusive exclusive to COLD pages -- we cache once fetched -- area for subclass */

            // ensure notesCollection is never null for ease in adding/setting if it doesn't yet exist
            // if any notes exist for the page, a new collection is set in the viewer loading WF in the document model
            notesCollection: new Backbone.Collection() ,

            /* states*/
            wasRequested: false, /* request to sent to CRE */
            isLoaded: false,
            loadError: false // Set to true there was an error loading the page. TODO -- should be null for no error, or the error message itself

        };

    },


    /**
     * Note: page number set in collection parse.
     * TODO:
     * - move all to constructor for simplicity in the use of attr value and .get,
     *  and get rid of _isPageType( attr ) fns
     */
    parse: function( pageAttrs, options ) {

        var isRenderable = this._isRenderable( pageAttrs.gosInfo, pageAttrs.pageType );

        /*
         * Would be clearer if get orig dims to render ...
         * height and width are either from the model, unrenderableOriginalDimensions, or unknownOrigDimsDimensions.
         * These would be the 'placeholder' dimensions when first rendered pre-image load.
        */

        // Note: getSetWidth also used in above calc (and requires fn param set in constructor)
        // TODO:
        // - These are probably better set on the constructor, not parse
        // - make functions for .get('height'), 'width') to make references easier to find and change
        // note: these are 'derived' in a sense ... they aren't the actual (eg can be requested at a smaller aspect ratio )
        // maybe need to take both into account

        var derivedAttrs = {

            height: this._getHeightDerivedFromWidth( pageAttrs, isRenderable ),
            width: this._getSetWidth( pageAttrs, isRenderable ),

            isRenderable: isRenderable,
            parentDocument: options.parentDocument,
            imageFileType: options.imageFileType

        };


        return _.extend( pageAttrs, derivedAttrs );

    },
    /*
    *   Only called on parse (not yet set).
    *   Renderable pages' are not GOS or GOS with a valid file extension.
    *   DVBC-1476 -- now considering multi pg GOS types unrenderable.
    *   Note -- Url Pages: these are renderable except in PDF mode (which will show an unrenderable view --
     *  so they are considered renderable ...  this is somewhat hacky.
     *  DVBC-1704 - TODO: ultimately should do a larger refactor where URL pages aren't considered renderable.
    * */
    _isRenderable: function(gosInfo, pageType) {

        if ( this._pageTypeIsMultipartGos(pageType) )
            return false;

        return !gosInfo
            ? true
            : _.contains( ViewerSettings.prototype.renderableFileExts,  Util.getFileExtension( gosInfo.filename).toUpperCase() );
    },

    isRenderable: function() {
        return this.get('isRenderable');
    },
    // Add the the below clause or clause to allow rotation of GOS 'image' types; waiting on DOCVIEW-98
    //      || ( this.isGOS() && this._hasImageTypeFileExtension() );
    isRotatable: function() {
        return this.isFddImage() && !this.imgLoadFailed();
    },

    _pageTypeIsGOS: function(type) {
        return type === 'FDD_GOS_TYPE';
    },
    // http://maven.feith.com/feith/data-services/blob/DEVELOPMENT/Common/src/main/java/com/feith/dataservices/common/objects/storage/FddObjectType.java
    // types where isCold is true
    _pageTypeIsCold: function(type) {
        return type.indexOf('COLD') > -1 || type === 'FDD_UTF8_TEXT_OPTREC' || type === 'FDD_UTF8_COMPRESS_OPTREC';
    },
    _pageTypeIsURL: function(type) {
        return type === 'FDD_URL_OPTREC';
    },
    _pageTypeIsFormsIQ: function(type) {
        return type === 'FDD_FORMSIQ_OPTREC';
    },
    _pageTypeIsParsedEmail: function(type) {
        return type === 'FDD_EML_V2_OPTREC' || type === 'FDD_EML_OPTREC';  /* note: Tom says now treating email the same as parsed email */
    },
    _pageTypeIsFddImage: function(type) {
        return type === 'FDD_IMAGE_TYPE';
    },
    _pageTypeIsWindowsText: function(type) {
        return type === 'FDD_CF_TEXT_OPTREC';
    },
    _pageTypeIsMultipartGosSkeleton: function(type) {
        return type === 'FDD_GOS_TOC_OPTREC';
    },
    // These should never really exist in Doc Viewer -- can't be requested as a document,
    // and are only used to comprise the Skeleton.
    _pageTypeIsMultipartGosPart: function(type) {
        return type === 'FDD_GOS_V3_OPTREC';
    },

    // Type 22 & 23 respectively
    _pageTypeIsMultipartGos: function(type) {
        return this._pageTypeIsMultipartGosSkeleton(type) || this._pageTypeIsMultipartGosPart(type);
    },

    isFddImage: function() {
        return this._pageTypeIsFddImage( this.get('pageType') );
    },
    /* Note: Old applications may have never have written this gosInfo attr to DB -- it can be NULL, resulting in errors --  can use this to check instead of attribute presence */
    isGOS: function() {
        return this._pageTypeIsGOS (this.get('pageType') );
    },
    isCold: function() {
        return this._pageTypeIsCold( this.get('pageType') );
    },
    isUrl: function() {
        return this._pageTypeIsURL( this.get('pageType') );
    },
    isFormsIQ: function() {
        return this._pageTypeIsFormsIQ( this.get('pageType') );
    },
    isParsedEmail: function() {
        return this._pageTypeIsParsedEmail( this.get('pageType') );
    },
    /* DVBC-1111 - this type is obsolete but still supported -- fdd treats as text but treat by showing image from cre */
    /* will be displayed as 8.5 x 11 by default */
    isWindowsText: function() {
        return this._pageTypeIsWindowsText( this.get('pageType') );
    },
    // Either 22 or 23 (the skeleton or part).
    isMultipartGos: function() {
        return this._pageTypeIsMultipartGos( this.get('pageType') );
    },

    isMultipartGosSkeleton: function() {
        return this._pageTypeIsMultipartGosSkeleton( this.get('pageType') );
    },

    isMultipartGosPart: function() {
        return this._pageTypeIsMultipartGosPart( this.get('pageType') );
    },
    /*
     * Instead of checking for page types -- isGos or isMultipartGosPart,
     * just return whether gosInfo is populated.
     * Used for consistency in printing gosInfo in various views: pageInfo, unrenderable page views, etc
     */
    hasGosInfo: function() {

        var gosInfo = this.get('gosInfo');
        return gosInfo !== undefined && gosInfo !== null;

    },

    isGosHtmlFile: function() {

        if ( !this.isGOS() )
            return false;

        var fileExt = this.getFileNameExtension();
        return fileExt && _.contains( ['HTML', 'HTM', 'XHTML'], fileExt.toUpperCase() );

    },

    renderUrlViewForDocAndPageMode: function() {
        return this.isUrl() || this.isFormsIQ() || this.isGosHtmlFile();
    },

    /*
    *  Note: GOS html files will be loaded as image previews in thumbnails.
    *  FormsIQ pages now rendered as images -- could potentially do for URL
    *  pages, but still get an error for them when requested from CRE.
    * */
    renderUrlViewForThumbnail: function() {
        return this.isUrl();
    },

    setRotation: function(deg) {
        this.set({ rotation: deg }, {silent: true});
        return this;
    },

    updateUnknownDimensionsPostLoad: function(loadDimensions) {
        this.set(loadDimensions);
    },
    imgLoadFailed: function() {
        return this.get('loadError');
    },

    /* --- DIMENSIONS ---- */


    // Return the 'derived dimensions' -- don't include rotation
    getDimensions: function() {

        return {
            width: this.get('width'),
            height: this.get('height')
        };
    },


    getRotatedDimensions: function() {

        var dims = this.getDimensions(),
            rotation = this.get('rotation'),
            rIs90 = rotation === 90 || rotation === 270;

        return {
            width: rIs90 ? dims.height : dims.width,
            height: rIs90 ? dims.width : dims.height
        };

    },

    getRotatedDimensionsWithScale: function(scale) {

        var rotatedDims = this.getRotatedDimensions();

        if ( !scale )
            return rotatedDims;

        return {
            width: Math.round( rotatedDims.width * scale ),
            height: Math.round( rotatedDims.height * scale )
        };

    },

    getRotatedWidth: function() {

        var rotation = this.get('rotation');

        return rotation !== 90 && rotation !== 270
            ? this.get('width')
            : this.get('height');

    },

    getRotatedHeight: function() {

        var rotation = this.get('rotation');

        return rotation !== 90 && rotation !== 270
            ? this.get('height')
            : this.get('width');

    },

    /* -- Original Image Properties ( only appliable to FDD images, should subclass & have better organization */

    /*
    * Return the original dimensions, optionally with scale applied -- if provided
    * Note: this is only for FDD images which would have original image properties ...
    * */
    originalDimensions: function(scale) {

        scale = scale ? scale : 1;

        var orDims = this.get('originalImageProperties');
        if (!orDims)
            return null;

        return {
            w: orDims.width * scale,
            h: orDims.height * scale
        };

    },

    // Note: only applicable for FDD images
    getOriginalAspectRatio: function() {

        var orDims = this.get('originalImageProperties');
        if (!orDims)
            return null;

        return orDims.width / orDims.height;
    },

    /* includes scale adjustments if provided -- original always rotated */
    getOriginalCenterPtRotated: function(scale) { //*** NO DPI -- don't rotate?

        var origDims = this.originalDimensions(scale ? scale : 1);  //--> w, h scaled -- need to do first b/f rotate
        if (!origDims)
            return null;

        var absRot = Math.abs(this.get('rotation'));
        var rIs90  = absRot === 90 || absRot === 270;
        var rtDims = {
            w: rIs90 ? origDims.h : origDims.w,
            h: rIs90 ? origDims.w : origDims.h
        };
        return {
            x: Math.round(rtDims.w / 2), //want an integer
            y: Math.round(rtDims.h / 2)
        };
    },

    /**
     * Intermediate refactor in lieu of subclassing ( eg for COLD pages ).
     * For FDD images, original image dimensions; for COLD, the size of the generated text,
     * which is the size of the canvas we provide for drawing on.
     */
    getOriginalPageCanvasDimensions: function() {

        if ( this.isCold() ) {

            /*  grid model only know if page was loaded ( and text was retrieved ) in page mode  */
            var gridModel = this.getTextGridModel();
            if ( !gridModel )
                return null;

            /* Normalize w, h to mimiick other fns -- TODO: refactor all .w, .h */
            var dims = gridModel.actualDimensions();
            return {
                w: dims.width,
                h: dims.height
            };

        }

        return this.originalDimensions();

    },



    /* ------ end dimensions ------ */


    /**
     * Should indicate when use conversion constant or not -- see other fns, other page -- and put on base page
     * (used for rotate -- need to include dpi calcs UNSCALED && NOT ROTATION !
     */
    getOriginalCenter: function() {

        var origImgProps = this.get('originalImageProperties');
        if ( !origImgProps )
            return null;

        var conv = ShapeUtils.INCHES_TENTHS_MM_TRANS,
            ow = origImgProps.width / origImgProps.originalHDPI / conv,
            oh = origImgProps.height / origImgProps.originalVDPI / conv;
        return {
            x: Math.round( ow / 2 ),
            y: Math.round( oh / 2)
        };
    },

    /**
     * The original center with current rotation taken into account
     */
    getOrigRotatedCenter: function() {

        var origImgProps = this.get('originalImageProperties');
        if (!origImgProps)
            return null;

        var conv = ShapeUtils.INCHES_TENTHS_MM_TRANS,
            ow = origImgProps.width / origImgProps.originalHDPI / conv,
            oh = origImgProps.height / origImgProps.originalVDPI / conv;

        // Don't really need 360 (server does)
        // make pg fn for isRot90 -- (also one that returns the width and height of them) ... ?
        var absRot = Math.abs( this.get('rotation') ),
            rIs90  = absRot === 90 ||absRot === 270 ;

        return {
            x: rIs90 ? Math.round(oh / 2) :  Math.round(ow / 2),
            y: rIs90 ?  Math.round(ow / 2) : Math.round(oh / 2)

        };
    },

    getDPI: function() {

        var originalImageProperties = this.get('originalImageProperties');
        if ( !originalImageProperties )
            return null;

        return originalImageProperties.normalizedDPI;
    },

    // Returns either 'jpeg' or 'tiff' -- defined in doc info fetch based on image compression type.
    getFDDImageType: function() {

        var originalImageProperties = this.get('originalImageProperties');
        if ( !originalImageProperties )
            return null;

        return this.get('originalImageProperties').type;
    },

    getOriginalImgCompressionType: function() {

        var originalImageProperties = this.get('originalImageProperties');
        if ( !originalImageProperties )
            return null;

        return this.get('originalImageProperties').type;
    },

    /* ----------------------------- File Name ------------------------------ */

    /*
    * Central point for getting page names.
    * Return the page name appended with file extension if provided.
    * If fileExtension not provided, use that derived from the page inherently.
    * ( It currently appears that page names are always displayed with a file extension ).
    * */
    getPageName: function( fileExtension, forDownload ) {

        var nameWithoutExtension = this._getPageNameWithoutExtension();

        var extension = fileExtension
            ? fileExtension
            : this.getFileNameExtension(); // some overlap with GOS, but worth if for the clarity

        var pageName = nameWithoutExtension + '.' + extension;

        if (forDownload)
            pageName = Util.sanitizeFileNameForFileSystem(pageName);

        return pageName;

    },

    _getPageNameWithoutExtension: function() {

        var gosInfoFileName = this.gosInfoFileName();

        if (gosInfoFileName)
            return Util.stripFileExtension( gosInfoFileName );

        var derivedDocName = this.getParentDocument().getNonGosNameWithoutExtension();

        // Add the page # to distinguish pages in the document that would otherwise have the same name.
        return derivedDocName + '_' + this.get('number');

    },

    /*
    * Returns either the gosInfo.fileName if it exists or null.
    * Convenience to both determine if the name exists and return it if it does.
    * */
    gosInfoFileName: function() {
        var gos = this.get('gosInfo');
        return gos && gos.filename && gos.filename.length > 0
            ? gos.filename
            : null;
    },

    /*
    *  Note: applies only to requests for FDD images (which include image overlays).
    *  This is what would be printed as the file name in corresponding <image> tags.
    *  For text (COLD) pages, the 'overlay' property is populated if the page has an overlay applied.
    *  If there's no overlay on the COLD page, this won't be requested.
    *  Note:
    *   - Overlay images are not requested in 'preview' requests.
    *   - The 'address' is the 'location' of the image overlay (the image requested);
    *     it won't exist if there's no image overlay applied.
    *   - The name for an image overlay only comes into play if the user clicks 'save as' on the image
    *    in the browser ( the page name is different ).
    *   - Use 'forDownload' so downloads from image tags are 'file system escaped'
    * */

    getCreImgRequestFileName: function() {

        var overlay = this.get('overlay'),
            fileType = this.get('imageFileType');

        return overlay && overlay.address
            ? overlay.overlayName + '-' + 'overlay' + '.' + fileType
            : this.getPageName( fileType, 1 );
    },

    // Provide hasGosInfo in case we already know this prior to the fn call.
    getFileNameExtension: function( hasGosInfo ) {

        if ( hasGosInfo || this.hasGosInfo() )
            return Util.getFileExtension( this.get('gosInfo').filename );

        if ( this.isFddImage() ) {
            // Return the shortened jpg for type 'jpeg': this is what's output by CRE (and is shorter)
            // The only other type would be tiff
            return this.getFDDImageType() === 'jpeg' ? 'jpg' : 'tiff';
        }

        if ( this.isCold() )
            return 'txt';

        if ( this.isParsedEmail() )
            return 'eml';

        return '';

    },


    /* ----------------------------- Render Requests  ------------------------------ */

    getImgRenderRequest: function() {

        // Temp for testing CRE ...
        var INCLUDE_NOTES = 1; //
        if (PRODUCTION) {
            INCLUDE_NOTES = 0;
        }

        return {
            renderRequest: {
                renderingParameters: {
                    containerType: 'raw',
                    pageType: this.get('imageFileType'),
                    imageParameters: {
                        fixWidth: this._getFixedWidthForImgRenderRequest()
                    },
                    preview: !this.isFddImage()
                },
                slices: [{
                    documentAddress: this.get('parentDocument').docAddress(),
                    pageIds: [ this.get('pageId') ],
                    fddImageParameters: {
                        disableFddRotation: true
                    },
                    pageNotesByType: INCLUDE_NOTES
                        ? ['REDACTION_NOTE', 'GRAPHIC_NOTE', 'HIGHLIGHT_NOTE', 'GRAPHIC_STAMP', 'INITIALS',
                        'SIGNATURE', 'SVG_SIGNATURE', 'SVG_GRAPHIC_NOTE', 'STRIKE_THROUGH', 'FLOATING_REDACTION_NOTE', 'FULL_PAGE_REDACTION', 'GRAPHIC_TEXT_STAMP' ]
                        : []
                }],
                destinations: {
                    allowDownload: true
                }
            }

        };


    },

    // Width is be the default -- applicable only to thumbnails; N/A for page mode
    // Document mode now overrides with rotated width
    _getFixedWidthForImgRenderRequest: function() {
        return this.get('width');
    },

    /**
     * Essentially that of the doc, then alters the resp for the page.
     * (non-image)
     */
    nonImgRenderRequest: function() {

        var parentDoc = this.get('parentDocument'),
            req = parentDoc.docRenderRequest.apply(parentDoc, arguments);


        req.renderRequest.slices[0]['pageIds'] = [ this.get('pageId') ];


        return req;

    },

    /*
    * Only for COLD type pages -- would put there if/when subclass by type in addition to mode.
    * This is for the cold text, not the overlay image.
    * */
    getTextOverlayRenderRequest: function() {

        var imgReq = this.getImgRenderRequest();

        _.extend( imgReq.renderRequest.renderingParameters, {
            containerType: 'raw',
            pageType: 'raw'
        });

        return imgReq;
    },
    getOverlayImageRequest: function(address) {
        return  {
            renderRequest: {
                renderingParameters: {
                    containerType: 'raw',
                    pageType: this.get('imageFileType')
                },
                slices: [{  //note: single pg
                    documentAddress: {
                        containerType: address.containerType,
                        containerId:  address.containerId,
                        documentId: address.documentId
                    },
                    pageIds: [address.pageId]
                }
                ],
                destinations: {
                    allowDownload: true
                }
            }
        };
    },

    /*
     * Currently not using the cookie functionality (DVBC-1366, 1367) for downloads.
     * The cookie would be read at the window level so would want something to identify
     * the download and we aren't using this with the other cre downloads -- see download frame.
     * Provide inline as true to utilize for the src for HTML GOS iframe page loads (the are 'raw').
     * DVBC-1476 -- previously all downloads went to CRE; Multi-Part-Gos now go through different url.
     */
    getRawDownloadUrl: function(inline) {

        if ( this.isMultipartGos() )
            return fvChannel.request('apiUrl').multiPartGosPageDownload( this.getParentDocument(), this );

        //var DL_COOKIE = 'dlComplete';

        // Traditional CRE download

        var docContainer = this.getParentDocContainer(),
            CRE_ROOT = fvChannel.request('settings').getCRERoot(),
            url = CRE_ROOT + 'rest/v2/api/cre/raw/download?'; // maybe put on API_URL ... or make fn of ...

        // required
        url += 'containerType=' + docContainer.getType().toUpperCase() + '&';
        url += 'containerId=' + docContainer.getId()  + '&';
        url += 'docId=' + this.getParentDocument().getId();

        // now treating this as required for Doc Viewer purposes
        url += '&pageId=' + this.getId();

        // (true prob not necessary but in testing to identify the need to send a file in app.js)

        url += '&inline=' + (inline ? 'true' : 'false');
        url += '&filename=' + encodeURIComponent( this.getPageName( undefined, 1) );

        //url += '&cookieName=' + DL_COOKIE;

        return url;

    },

    /* ------------------------------------------------- */

    resetLoadState: function() {
        this.set({
            isLoaded: false,
            wasRequested: false,
            loadError: false
        }, {silent: true});
    },

    //TODO: mediate -- call off channel, don't pass in (?)
    shapeModelsToRender: function() {

        var shapes = this.drawableNotes().map( _.bind(function(n) {
            return n.shapeModelsToRender(this);
        }, this));

        /* turn array of shapes per note into one large array per page */
        shapes = _.flatten(shapes);
        return shapes;


    },

    /**
     * Return collection of notes of this page that are drawable AND user has access to view
     * ( if user is not in the note's access group, it's not returned from the server ).
     */
    drawableNotes: function() {

        var notes = this.get('notesCollection').filter( function(n) {
            return n.isDrawable();
        });

        return new PageNotes( notes );

    },

    // Only for txt pages ... ideal candicate for subclass
    hasImageOverlay: function() {
        var overlay = this.get('overlay');
        return overlay && overlay.address;
    },
    
    // Applicable to page types that are rendered in an iframe: URL, FormsIQ, and GOS HTML files
    getPageUrl: function() {

        if ( this.isGosHtmlFile() )
            return this.getRawDownloadUrl(1);

        return this.get('url');

    },
     // Don't mess with original is renderable for the page views for url pages -->
     // they will be treated as url page type views anyway -- this is simply for including them in pdf mode
    isRenderableInPDFMode: function() {
        return this.isRenderable() && !this.isUrl();
    },
    /* the unrenderable and url pages -- needed to retrieve those from isRenderableInPDFMode */
    isUrlOrUnrenderable: function() {
        return this.isUrl() || !this.isRenderable();
    },
    /* note: would only apply to GOS*/
    _hasImageTypeFileExtension: function() {
       return _.contains( ViewerSettings.prototype.validImgFileTypes, this.getFileNameExtension().toUpperCase() );
    },

    /* a derived type -- basically, should it render in the viewer like an image (vs a document) */
    /* note: may now want to change with rendering PDFs in single page mode for certain types */
    isImageType: function() {

        if ( this.isGOS() )
            return this._hasImageTypeFileExtension();

        if ( this.isFddImage() )
            //note: Paul -- would really only be applicable to JPG, TIFF -- where fdd sets the compressions --
            // compression isn't always the file type, only when uploaded
            return _.contains( ViewerSettings.prototype.validImgFileTypes , this.getOriginalImgCompressionType().toUpperCase() );

        return false;
    },
    getFriendlyName: function() {
        return PgNameXref[ this.get('pageType') ];
    },

    // Return whether page is downloadable from the CRE as 'raw' or if not provided, as a PDF.
    // Note: Gos Skeleton Pgs are not downloaded by the CRE.
    isDownloadable: function(isPDF) {

        // Url pages not working for either pdf/raw -- not sure if a bug with the CRE / not.
        // Note URL pages are considered renderable ( DVBC-1704)
        if (  this.isWindowsText() || this.isUrl() || this.isMultipartGosPart() )
            return false;

        // Raw Forms IQ pages: don't seem to work (PDF works); unsure if this is a bug in the CRE/not:
        // what's returned is a text file with the url to the formsIQ page.
        // GOS HTML pages: work for pdf/raw.
        if ( this.isFormsIQ() ) {
            return isPDF;
        }

        // Multi-Part-Gos Skeletons are downloadable RAW, though not via the CRE
        if ( this.isMultipartGosSkeleton() ) {
            return !isPDF;
        }

        // For PDF, true for any non GOS page or any 'renderable' GOS page determined by file extension
        // (and now either multi-part-GOS page types)
        if (isPDF) {
            return this.isRenderable(); // (this may belong better in 'isRenderable logic')
        }

        return true;
    },

    getSpinJSOptions: function() {
        return this.SPIN_JS_OPTS;
    },
    //TODO: put in with DVBC-1366 -- replace direct gets with these fns throughout codebase
    getParentDocument: function() {
        return this.get('parentDocument');
    },
    getParentDocContainer: function() {
        return this.getParentDocument().getDocContainer();
    },
    getId: function() {
        return this.get('pageId');
    },

    /**
     * DVBC-1382: return unique object of { reasonCode, count } from all redaction notes on the page
     * if there are no redaction notes or none have reason codes assigned, return null
     * could be optimized though performance shouldn't be an issue
     * currently unsorted ( this is later done upon display in the view)
     * if want the descriptions will need to derive from reason codes endpoint / collection ...
     * noteTypeFilter:
     *  - 'nonFullPage': regular: type D and B
     *  - 'fullPage': type E -- only full page redactions ( max is one )
     *   - undefined (or anything else): include all types (full page & non full page)
     */
    getReasonCodesCounts: function( noteTypeFilter ) {

        var pgCodesByCounts = {},
            aRedactionNotes;

        if ( noteTypeFilter === 'nonFullPage' ) {

            aRedactionNotes = this.getNonFullPageRedactionNotes();

        } else if ( noteTypeFilter === 'fullPage' ) {

            aRedactionNotes = this.getFullPageRedactionNotes();

        } else {

            aRedactionNotes = this.getRedactionNotes();
        }


        if (!aRedactionNotes || aRedactionNotes.length < 1)
            return null;

        _.each( aRedactionNotes, function(n) {

            var noteCodesByCounts = n.getReasonCodeCounts();
            if (!noteCodesByCounts)
                return; // (note has no codes assigned, next)

            for (var code in noteCodesByCounts) {
                pgCodesByCounts[code] = !_.contains( _.keys(pgCodesByCounts), code )
                    ? noteCodesByCounts[code]
                    : pgCodesByCounts[code] += noteCodesByCounts[code];
            }

        });

        if ( _.keys( pgCodesByCounts).length < 1 )
            return null;

        return pgCodesByCounts;

    },

    // Return true if the page has redaction notes
    hasRedactionNotes: function() {
        var aRedactionNotes = this.getRedactionNotes();
        return aRedactionNotes && aRedactionNotes.length > 0;
    },

    // Return array of redaction note models in the page
    getRedactionNotes: function() {
        return this.get('notesCollection').filter( function(n) {
            return n.isRedactionNote();
        });
    },

    getNonFullPageRedactionNotes: function() {
        return this.get('notesCollection').filter( function(n) {
            return n.isNonFullpageRedactionNote();
        });
    },

    // Should only ever by one per page -- not enforcing if read in by a client that doesn't enforce
    getFullPageRedactionNotes: function() {

        return this.get('notesCollection').filter( function(n) {
            return n.isFullPageRedactionNote();
        });

    },

    // Should only ever by one per page -- not enforcing if read in by a client that doesn't enforce
    hasAFullPageRedactionNote: function() {
        return this.get('notesCollection').find( function(note) {
            return note.isFullPageRedactionNote();
        }) !== undefined;
    },

    // called on: viewer init WF from document model after the note to set are known
    setNoteCollection: function(aNotes) {
        this.set('notesCollection', new Backbone.Collection(aNotes) ) ;
    },
    addNewPageNote: function(note) {
        this.get('notesCollection').add(note);
    },
    deleteNote: function(note) {
        this.get('notesCollection').remove(note);
    },
    /* Return if the user can draw page notes atop the page.
     * Note: imgLoad failed only applies to those pages that have already loaded in error --
     * it's an extra check that can't hurt.
     */
    supportsAnnotation: function() {

        if ( this.imgLoadFailed() )
            return false;

        return this.isFddImage() || this.isCold();

    },

    allowCreationOfFullPageRedaction: function() {
        return !this.isCold() && !this.hasAFullPageRedactionNote();
    },
    /**
     * Determine whether to print the preview icon on page views.
     * Here to clean up some old logic on the base page view.
     */
    renderPrintPreviewIconOnPageImageViews: function() {

        // It's only printed in the template if the page has unknown dimensions.
        if ( this.isFddImage() )
            return false;

        // This was the existing logic encountered 4.9.20 -- don't remember why ...
        // we may only be concerned with COLD and GOS page types for the previews
        return !this.isParsedEmail() && !this.isWindowsText();

    },

    resizePageFromDummyDimensionsPostLoad: function() {
        return !this.isFddImage() && ! this.renderUrlViewForDocAndPageMode(); // Forget why the latter is working ...
    },

    /**-- Cold Specific -- */
    getTextGridModel: function() {
        return this.get('textGridModel');
    },

    setTextGridModel: function( model ) {
        this.set( 'textGridModel', model );
    }


    /** -- End Cold -- */

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/basePg.js
 ** module id = 269
 ** module chunks = 0
 **/